// @flow
import type {
  Worklog,
  IntervalType,
} from 'chronos-types';
import React from 'react';
import * as utils from 'chronos-utils';

import {
  Cell, MonthDay,
} from './styled';

type Props = {
  style: Object,
  worklogs: {
    [string]: {
      [string]: Worklog,
    }
  },
  currentDate: IntervalType,
  columnIndex: number,
}

const GridFooterCellRenderer = ({
  style,
  worklogs,
  currentDate,
  columnIndex,
}: Props) => {
  const date = currentDate.start.plus({ days: columnIndex });
  const worklog = (worklogs && worklogs[date.toFormat('yyyy-MM-dd')]) || {};
  const total = Object.keys(worklog).reduce((t, id) => t + worklog[id].timeSpentSeconds, 0);
  return (
    <Cell style={style}>
      <MonthDay>
        {utils.stj(total)}
      </MonthDay>
    </Cell>
  );
};


export default GridFooterCellRenderer;
